<template>
    <a :href="href" :class="{'pointer-events-none': disabled}" class="flex items-center justify-center text-button px-4 py-[9px] rounded-full">
        <slot name="icon-before" />
        <slot/>
        <slot name="icon-after" />
    </a>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>

</style>
